module.exports = __webpack_public_path__ + "static/media/s_bar5.05feef78.svg";